import { getNameOfLetterInArabic, getOrdinalNumberInArabic } from '../lib/words'

export const GAME_TITLE = 'الوِرد'

export const WIN_MESSAGES = ['!أحسنت صنعاً']
export const GAME_COPIED_MESSAGE = 'نُسخت النتيجة إلى الحافظة'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'يجب أن تكون الكلمة من 5 حروف'
export const WORD_NOT_FOUND_MESSAGE = 'هذا التخمين غير موجود في قاموس اللعبة'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `الكلمة الصحيحة هي ${solution}`
export const ENTER_TEXT = '↵'
export const DELETE_TEXT = 'مسح'
export const STATISTICS_TITLE = 'إحصائيات'
export const GUESS_DISTRIBUTION_TEXT = 'توزيع التخمينات'
export const NEW_WORD_TEXT = 'الوِرد القادم سيكون متاح في'
export const SHARE_TEXT = 'شارك (انسخ النتيجة) 📋'
export const TOTAL_TRIES_TEXT = 'عدد المحاولات'
export const SUCCESS_RATE_TEXT = 'نسبة النجاح'
export const CURRENT_STREAK_TEXT = 'تتالي مرات الربح الحالية'
export const BEST_STREAK_TEXT = 'أفضل تتالي ربح'
export const SUPPORT_US_TEXT = 'ادعمنا بفنجان قهوة ☕'
export const SETTINGS_MODAL_TITLE_TEXT = 'الإعدادات'
export const HARD_MODE_TEXT = 'المستوى الصعب'
export const DARK_MODE_TEXT = 'الوضع الليلي'
export const HIGH_CONTRAST_MODE_TEXT = 'وضع التباين العالي'
export const HARD_MODE_ALERT_MESSAGE =
  'يمكنك تفعيل المستوى الصعب في بداية اللعبة فقط'
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `يجب أن تستخدم حرف ${getNameOfLetterInArabic(
    guess
  )} (${guess}) في المربع ${getOrdinalNumberInArabic(position)}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `يجب أن تستخدم حرف ${getNameOfLetterInArabic(letter)} في مكان ما`
export const CANNOT_ENABLE_HARD_MODE_MESSAGE =
  'يمكنك رفع مستوى الصعوبة في بداية اللعبة فقط'
